module.exports = __webpack_public_path__ + "static/img/pay_bg.2a07e18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/promotion/pay_bg.png
// module id = ZebE
// module chunks = 0